class FacetForm extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form');
    if (!this.form) return;

    this.form.querySelectorAll('input[type="checkbox"], select[data-auto-submit]').forEach((control) => {
      control.addEventListener('change', () => this.form.requestSubmit());
    });
  }
}

class FacetDrawer extends HTMLElement {
  connectedCallback() {
    this.trigger = this.querySelector('[data-facet-open]');
    this.dialog = this.querySelector('dialog');
    this.closeButton = this.querySelector('[data-facet-close]');

    if (!this.trigger || !this.dialog || !this.closeButton) return;

    this.trigger.addEventListener('click', () => this.open());
    this.closeButton.addEventListener('click', () => this.close());
    this.dialog.addEventListener('cancel', (event) => {
      event.preventDefault();
      this.close();
    });
    this.dialog.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      event.preventDefault();
      this.close();
    });
    this.dialog.addEventListener('click', (event) => {
      if (event.target === this.dialog) this.close();
    });
    this.dialog.addEventListener('close', () => this.afterClose());
  }

  open() {
    this.trigger.setAttribute('aria-expanded', 'true');
    document.documentElement.classList.add('scroll-locked');
    this.dialog.showModal();
    this.closeButton.focus();
  }

  close() {
    if (this.dialog.open) this.dialog.close();
  }

  afterClose() {
    document.documentElement.classList.remove('scroll-locked');
    this.trigger.setAttribute('aria-expanded', 'false');
    this.trigger.focus();
  }
}

if (!customElements.get('facet-form')) {
  customElements.define('facet-form', FacetForm);
}

if (!customElements.get('facet-drawer')) {
  customElements.define('facet-drawer', FacetDrawer);
}
